import type {ComponentType} from 'react';

export enum ChipTone {
    Gold = 'GOLD',
    Silver = 'SILVER',
    Sage = 'SAGE',
}

export type CardSurfaceTone = 'light' | 'dark';

export interface BankCardBrandProps {
    logoUrl: string;
    institutionDisplayName: string;
}

export interface BankCardSkin {
    Face: ComponentType;
    Brand: ComponentType<BankCardBrandProps>;
    chipTone: ChipTone;
    hasMastercard: boolean;
    surfaceTone: CardSurfaceTone;
    contentColor: string;
    labelColor: string;
    contactlessColor: string;
    mastercardWordColor: string;
}
